import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import {
    VarianceEscalationCommentsModalComponent,  VarianceEscalationPopupModalComponent,     
    VarianceInvestigationStatusAddEditComponent,     
    VarianceRoutingModule
} from '@inventory/components/variance';
import { NgxPrintModule } from 'ngx-print';
import { varianceDeclarationComponents } from './variance-routing.module';
@NgModule({
  declarations: [...varianceDeclarationComponents],
  imports: [
    CommonModule,
    VarianceRoutingModule,
    LayoutModule,
    MaterialModule,
    SharedModule,
    NgxPrintModule
  ],
  entryComponents: [VarianceInvestigationStatusAddEditComponent, VarianceEscalationPopupModalComponent, VarianceEscalationCommentsModalComponent]
})
export class VarianceModule { }
